import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@env/environment';

@Pipe({
  name: 'assetUrl',
})
export class AssetUrlPipe implements PipeTransform {
  transform(path: string): string {
    if (environment.isGeotabEnv) {
      const pathStartsWithSlash = path.startsWith('/');
      return pathStartsWithSlash ? `${environment.geotabDeployUrl}${path}` : `${environment.geotabDeployUrl}/${path}`;
    }
    return path;
  }
}
